module.exports = __webpack_public_path__ + "fonts/MTP_ySUJH_bn48VBG8sNSg7aC6SjiAOpAWOKfJDfVRY.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/MTP_ySUJH_bn48VBG8sNSg7aC6SjiAOpAWOKfJDfVRY.woff2
// module id = 385
// module chunks = 0